module.exports = ".legenda-wrapper\r\n{\r\n    margin: 0 auto;\r\n    padding: 15px;\r\n    max-width: 720px;\r\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/pesquisa/legenda/legenda.component.css
 ** module id = 494
 ** module chunks = 0
 **/